import { Container } from "@mui/material";
import { SocialMediaDriver } from "../interaction_tracking/network";
import { Author } from "../manifest/models/author.models";
import { Post } from "../posts/post";
import { PostController } from "../posts/post.controller";
import { PostData, PostEvent } from "../posts/post.models";
import "./social_media_feed.css";

export interface SocialMediaFeedProps {
  posts: PostData[];
  onLikePostClicked: PostEvent;
  onDislikePostClicked: PostEvent;
  onSharePostClicked: PostEvent;
  onCommentsClicked: PostEvent;
  driver: SocialMediaDriver;
  testId: string;
  user?: Author;
}

export function SocialMediaFeed(props: SocialMediaFeedProps) {
  return (
    <Container maxWidth="sm" className="social-media-feed" id="feedContainer">
      {props.posts.map((post) => {
        if (props.user == null) {
          throw new Error(
            `Rendering post ${post.id} but no site-wide user registered!`,
          );
        }

        const controller = new PostController(
          post,
          props.driver,
          props.testId,
          props.user,
        );
        return (
          <Post
            controller={controller}
            showValidationErrors={true}
            hasErrors={false}
            key={post.id}
            user={props.user}
          />
        );
      })}
    </Container>
  );
}
